import { useMutation } from '@apollo/client'
import { updateNote as updateNoteGql }
   from 'src/graphql/mutations/updateNote.gql'

const useUpdateNote = (mutationHookOptions) => {
   const [updateNote, { called, client, data, error, loading }] =
      useMutation(updateNoteGql, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => updateNote({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      updateNote: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUpdateNote
